import React, { useContext, useRef, useState } from 'react';
import AppContext from '../../contexts/AppContext';
import htmlParse from 'react-html-parser';
import { isMobile, isTablet } from 'react-device-detect';

import './About.css';

const DOWN_BTN_ID = 'about-down-button';
const UP_BTN_ID = 'about-up-button';
const IS_DESKTOP = !isMobile && !isTablet;

export default function About({ onClose }) {
  const { dictionnary } = useContext(AppContext);
  const wrapperElement = useRef(null);
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [isScrollNeed, setIsScrollNeeded] = useState(0);

  function getScrollProgress() {
    const scrollSize =
      wrapperElement.current.scrollHeight - wrapperElement.current.clientHeight;

    setScrollPercentage(wrapperElement.current.scrollTop / scrollSize);
    setIsScrollNeeded(scrollSize > 5);
  }

  React.useEffect(() => {
    let interval = null;
    const stopScrolling = () => {
      clearInterval(interval);
      getScrollProgress();
    };
    const onDown = (event) => {
      clearInterval(interval);
      const target =
        event.targetTouches && event.targetTouches.length
          ? event.targetTouches[0].target
          : event.target;
      let direction = 0;
      if (target.id === UP_BTN_ID || event.target === UP_BTN_ID) {
        direction = -1;
      } else if (target.id === DOWN_BTN_ID || event.target === DOWN_BTN_ID) {
        direction = 1;
      }
      if (direction !== 0) {
        interval = setInterval(() => {
          wrapperElement.current.scrollTop += direction;
        }, 1);
      }
    };
    window.addEventListener('mousedown', onDown);
    window.addEventListener('touchdown', onDown);
    window.addEventListener('mouseup', stopScrolling);
    window.addEventListener('touchup', stopScrolling);
    return () => {
      stopScrolling();
      window.removeEventListener('mousedown', onDown);
      window.removeEventListener('touchdown', onDown);
      window.removeEventListener('mouseup', stopScrolling);
      window.removeEventListener('touchup', stopScrolling);
    };
  }, []);

  return (
    <>
      <div className={`about ${!isScrollNeed ? 'no-scroll' : ''}`}>
        <div
          className="about_wrapper"
          ref={wrapperElement}
          onScroll={getScrollProgress}
        >
          <header>
            <h1>{dictionnary.get('intro-title')}</h1>
          </header>
          {IS_DESKTOP && (
            <>
              {htmlParse(dictionnary.get('about-descr'))}
              <br />
              <br />
              {htmlParse(dictionnary.get('about-sharing'))}
            </>
          )}
          {!IS_DESKTOP && (
            <>{htmlParse(dictionnary.get('about-descr-mobile'))}</>
          )}
        </div>
        {IS_DESKTOP && (
          <button
            id="about-close-button"
            type="button"
            className="about-btn"
            onClick={() => {
              onClose();
            }}
          >
            Close
          </button>
        )}
        {IS_DESKTOP && isScrollNeed && (
          <>
            <button
              id={DOWN_BTN_ID}
              type="button"
              className={`about-btn ${
                scrollPercentage === 1 ? 'about-btn-disabled' : ''
              }`}
            >
              Down
            </button>
            <button
              id={UP_BTN_ID}
              type="button"
              className={`about-btn ${
                scrollPercentage === 0 ? 'about-btn-disabled' : ''
              }`}
            >
              Up
            </button>
          </>
        )}
      </div>
      {!IS_DESKTOP && (
        <button
          id="about-close-button"
          className="about-btn outside-button"
          type="button"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </button>
      )}
      {/*!IS_DESKTOP && (
        <>
          <button
            id={DOWN_BTN_ID}
            type="button"
            className={`about-btn outside-button ${
              scrollPercentage === 1 ? 'about-btn-disabled' : ''
            }`}
          >
            Down
          </button>
          <button
            id={UP_BTN_ID}
            className={`about-btn outside-button ${
              scrollPercentage === 0 ? 'about-btn-disabled' : ''
            }`}
            type="button"
          >
            Up
          </button>
        </>
      )*/}
    </>
  );
}
